import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JavaService } from 'src/app/java.service';

@Component({
    selector: 'app-choose-pin',
    templateUrl: './choose-pin.component.html',
    styleUrls: ['./choose-pin.component.css']
})
export class ChoosePinComponent implements OnInit {

    constructor(
        private _router: Router,
        private _java: JavaService,
    ) { }

    ngOnInit(): void {
    }

    onBack() {
        this._java.javaConnector.goBack();
    }

    onSubmit(pin: string) {
        this._router.navigate(['/tr/confirm-pin/'], {
            queryParams: {
                pin,
            },
        });
    }
}
